import PropTypes from 'prop-types'
import TruncatedString from '../TruncatedString/TruncatedString'
import classes from './Group.module.scss'

const Group = ({
  label,
  limit
}) =>
  <span className={classes.Group}>
    <span
      aria-hidden // Hide from screen readers
      style={{ userSelect: 'none' }} // Can't select this dot
    >
      &#11044;
    </span>
    {' '}
    <TruncatedString
      limit={limit}
      value={label || ''}
    />
  </span>

Group.propTypes = {
  label: PropTypes.string.isRequired,
  limit: PropTypes.number.isRequired
}

export default Group
